import { formatRateWithType } from '~utils/rateFormatting';

interface ChargeRate {
  isPercentRate: boolean;
  rate: number | null;
  rateType: string | null;
}

export function formatChargeRate(
  { isPercentRate, rate, rateType }: ChargeRate,
  currencyFormatter: (value: number | string) => string,
  unitStyle: 'full' | 'short' = 'full',
) {
  if (isPercentRate && rate !== null) {
    return `${rate}%`;
  }

  return formatRateWithType(rate, rateType, currencyFormatter, { unitStyle });
}
